import { usersList } from './apiSlice'

export const patientList = usersList.injectEndpoints({
    endpoints: (builder) => ({
        getMonitorAssociatedToPatientList: builder.query({
            query: () => `patients/list-linked-monitor-users`,
            providesTags: (result = [], error, arg) => error === undefined ? [
                'AssociatedMonitorToPatient',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ patient_id }) => ({ type: 'AssociatedMonitorToPatient', id: patient_id }))
            ] : [],
            // invalidatesTags: ['SelectedOrg','OrganizationList','AssociatedProviderOrg']
        }),
        getProviderAssociatedToPatientList: builder.query({
            query: () => `patients/list-linked-providers`,
            providesTags: (result = [], error, arg) => error === undefined ? [
                'AssociatedProviderToPatient',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ patient_id }) => ({ type: 'AssociatedProviderToPatient', id: patient_id }))
            ] : [],
            // invalidatesTags: ['SelectedOrg','OrganizationList','AssociatedProviderOrg']
        }),
        getObserversAssociatedToPatientList: builder.query({
            query: () => `patients/list-linked-observers`,
            providesTags: (result = [], error, arg) => error === undefined ? [
                'AssociatedObserverToPatient',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ patient_id }) => ({ type: 'AssociatedObserverToPatient', id: patient_id }))
            ] : [],
            // invalidatesTags: ['SelectedOrg','OrganizationList','AssociatedProviderOrg']
        }),
        patientVitalChangeHistoryList: builder.query({
            query: (searchParams) => `patients/list-changes?${searchParams}`,
            providesTags: ['PatientActivityHistory']

        }),
        exportPatientVitalActivityHistory: builder.mutation({
            query: ({ sort, columns, username, dateformat, params }) => {
                const queryParams = Object.entries(params)
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
                return {
                    url: `patients/export-vital-changes?${queryParams}`,
                    method: 'POST',
                    body: { "columns": columns, "target_user_name": username, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
                };
            },
        }),
        VitalReadingList: builder.query({
            query: (searchParams) => `providers/list-historical-readings?${searchParams}`,
            providesTags: ['PatientActivityHistory']

        }),
        viewPatient: builder.query({
            query: (id) => `/patients/${id}`,

            providesTags: (result, error, arg) => [{ type: 'Patient', id: arg }],

        }),
        exportDeviceVitalReadingList: builder.mutation({
            query: ({ columns, dateformat, params }) => {
                const queryParams = Object.entries(params)
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
                return {
                    url: `patients/historical-data?${queryParams}`,
                    method: 'POST',
                    body: { "columns": columns, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
                };
            },
        }),
        getPatientWellnessDetails: builder.query({
            query: () => `patients/vital-data`,
            // invalidatesTags: ['SelectedOrg','OrganizationList','AssociatedProviderOrg']
        }),
        viewUser: builder.query({
            query: () => `patients/view-profile`,
            providesTags: ['ViewUser'],


        }),
        exportPatientWellnessNotes: builder.mutation({
            query: ({ dateformat, patientId, noteType, filter, start_date, end_date, user_id }) => {
                let queryString = `patients/export-note/${patientId}?note_type=${noteType}`;
                // Conditionally include filter, start_date, and end_date if they are present
                if (filter) queryString += `&filter=${filter}`;
                if (start_date) queryString += `&start_date=${start_date}`;
                if (end_date) queryString += `&end_date=${end_date}`;
                console.log('startdate:', start_date, "enddate:", end_date, "filter:", filter);
                const body = {
                    "dateformat": dateformat,
                    "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
                };

                // Conditionally include user_id in the body if it's present
                if (user_id) {
                    body.user_id = user_id;
                }
                console.log(body, "api call body");

                return {
                    url: queryString,
                    method: 'POST',
                    body: body
                };
            },
        }),
        listWellnessNotes: builder.query({
            query: ({ id, body, page = 1 }) => {
                const { start_date, end_date } = body;

                // Construct query parameters
                const queryParams = [`page_number=${page}&limit=15`]; // Add the page parameter

                if (start_date || end_date) {
                    queryParams.push('filter=true');
                }
                if (start_date) {
                    queryParams.push(`start_date=${encodeURIComponent(start_date)}`);
                }
                if (end_date) {
                    queryParams.push(`end_date=${encodeURIComponent(end_date)}`);
                }

                const url = `/patients/list-wellness-note?type=wellness-note${queryParams.length > 0 ? `&${queryParams.join('&')}` : ''}`;

                return {
                    url,
                    method: 'POST',
                };
            },
            providesTags: (result, error, arg) => [{ type: 'Patient', id: arg }],
            invalidatesTags: ['Patient'],
        }),

        getHelpGuidePatient: builder.query({
            query: (queryParams) => ({
                url: `users/help-guides?${queryParams}`,
                method: 'GET',
            }),
            providesTags: ['Patient'], // Optional: useful for cache invalidation
        }),
        getHelpGuidePatientLogin: builder.query({
            query: (queryParams) => ({
                url: `users/help-guide-login?${queryParams}`,
                method: 'GET',
            }),
            providesTags: ['Patient'], // Optional: useful for cache invalidation
        }),
        transferFile: builder.mutation({
            query: org => ({
                url: `/transfer-file`,
                method: 'POST',
                body: org
            }),
        }),
        ActivityHistoryFileTransfer: builder.mutation({
            query: org => ({
                url: `users/record-activity`,
                method: 'POST',
                body: org
            }),
        }),
        editPatientTimezone: builder.mutation({
            query: ({ body }) => ({
                url: `patients/timezone`,
                method: 'PATCH',
                body: body
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'Patient', id: arg.id }, 'ViewUser']
        }),
        getAlertPreferences: builder.query({
            query: (type) => {
                // type can be 'patient' or 'care-partners'
                const queryParam = type ? `?type=${type}` : '';
                return `patients/alert-preferences${queryParam}`;
            },
            providesTags: (result, error, arg) => {
                // Different cache tags based on type
                if (arg === 'patient') {
                    return ['PatientAlertPreferences'];
                } else if (arg === 'care-partners') {
                    return ['CarePartnersAlertPreferences'];
                }
                return ['AlertPreferences']; // Default fallback
            },
        }),
        updatePatientAlertPreferences: builder.mutation({
            query: (body) => ({
                url: `patients/alert-preferences`,
                method: 'PATCH',
                body: body
            }),
            async onQueryStarted(body, { dispatch, queryFulfilled }) {
                // Update cache for 'patient' type query
                const patchResult = dispatch(
                    patientList.util.updateQueryData('getAlertPreferences', 'patient', (draft) => {
                        if (!draft) return;
                        const responseData = draft?.data || draft;
                        // Backend now returns only patient data when type=patient
                        const patientData = responseData?.patient || responseData;
                        if (patientData) {
                            Object.keys(body).forEach(key => {
                                patientData[key] = body[key];
                            });
                        }
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            },
            invalidatesTags: ['PatientAlertPreferences'] // Only invalidate patient cache
        }),
        updateCarePartnerAlertPreferences: builder.mutation({
            query: ({ carePartnerId, body }) => ({
                url: `patients/alert-preferences/${carePartnerId}`,
                method: 'PATCH',
                body: body
            }),
            async onQueryStarted({ carePartnerId, body }, { dispatch, queryFulfilled }) {
                // Update cache for 'care-partners' type query
                const patchResult = dispatch(
                    patientList.util.updateQueryData('getAlertPreferences', 'care-partners', (draft) => {
                        if (!draft) return;
                        const responseData = draft?.data || draft;
                        // Backend now returns only care_partners when type=care-partners
                        // Could be array directly or wrapped in care_partners property
                        const carePartners = Array.isArray(responseData)
                            ? responseData
                            : (responseData?.care_partners || []);
                        if (Array.isArray(carePartners)) {
                            const partner = carePartners.find(p => p.user_id === carePartnerId);
                            if (partner) {
                                Object.keys(body).forEach(key => {
                                    partner[key] = body[key];
                                });
                            }
                        }
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            },
            invalidatesTags: ['CarePartnersAlertPreferences'] // Only invalidate care-partners cache
        }),
        updateObserverAlertPreferences: builder.mutation({
            query: (body) => ({
                url: `observers/alert-preferences`,
                method: 'PATCH',
                body: body
            }),
            async onQueryStarted(body, { dispatch, queryFulfilled }) {
                // Update cache for ViewUser query (observer alert preferences are in userDetails)
                const patchResult = dispatch(
                    patientList.util.updateQueryData('viewUser', undefined, (draft) => {
                        if (!draft) return;
                        const responseData = draft?.data || draft;
                        // Alert preferences are in userDetails object
                        const userDetails = responseData?.userDetails || responseData;
                        if (userDetails) {
                            Object.keys(body).forEach(key => {
                                userDetails[key] = body[key];
                            });
                        }
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            },
            invalidatesTags: ['ViewUser'] // Invalidate ViewUser cache to refetch profile data
        }),


    })
})


export const {
    useGetMonitorAssociatedToPatientListQuery,
    useGetProviderAssociatedToPatientListQuery,
    useGetObserversAssociatedToPatientListQuery,
    usePatientVitalChangeHistoryListQuery,
    useExportPatientVitalActivityHistoryMutation,
    useVitalReadingListQuery,
    useExportDeviceVitalReadingListMutation,
    useViewPatientQuery,
    useGetPatientWellnessDetailsQuery,
    useViewUserQuery,
    useListWellnessNotesQuery,
    useExportPatientWellnessNotesMutation,
    useGetHelpGuidePatientQuery,
    useGetHelpGuidePatientLoginQuery,
    useTransferFileMutation,
    useActivityHistoryFileTransferMutation,
    useEditPatientTimezoneMutation,
    useGetAlertPreferencesQuery,
    useUpdatePatientAlertPreferencesMutation,
    useUpdateCarePartnerAlertPreferencesMutation,
    useUpdateObserverAlertPreferencesMutation,

} = patientList
